import * as Yup from 'yup'

export const userLoginSchema = (languageData) => Yup.object().shape({
  email: Yup.string().required(languageData?.emailUserNameRequired),
  password: Yup.string().required(languageData?.passwordRequired)
})
